import { UserContextInterface } from '../context';

export type UserType = 'none' | 'client' | 'student' | 'member';

const isMember = (userCtx: UserContextInterface) =>
  userCtx?.user?.entity?.product_state?.includes('membership') ||
  userCtx?.user?.students?.some((student) =>
    student?.enablements?.some(
      (enablement) => enablement.product.short_name === 'active_membership'
    )
  );

const isClient = (userCtx: UserContextInterface) => userCtx?.user?.entity?.is_client;

const isStudent = (userCtx: UserContextInterface) =>
  userCtx?.user?.entity?.role === 'student' && userCtx?.user.students?.length > 0;

export default function getUserType(userContext: UserContextInterface): UserType {
  if (isMember(userContext)) return 'member';
  if (isStudent(userContext)) return 'student';
  if (isClient(userContext)) return 'client';
  return 'none';
}
